const variables = {
    white: '#ffffff',
    greenDown: '#53E88B',
    greenHight: '#15BE77',
    black: '#09051C',
    background: '#F7F8FE',
    active: '#EAFAF2',
    gradiant: 'linear-gradient(to right, #53e88b, #15be77)',
    boxShadown: 'inset 0 0 0 rgb(0 0 0 / 1%), 0 0 0 0 rgb(255 255 255), 4px 4px 4px rgb(0 0 0 / 10%)',
    boxShadownBotttom: '0 0px 0 rgb(0 0 0 / 1%), 0px 0 0 0 rgb(255 255 255), 0 0.5px 0px rgb(0 0 0 / 10%)',
    suave: '#0000006b',
    gray: '#3B3B3B'

}
export default variables